import { IClientTicketBrief } from '@bustickus/models-client';
import { ApiTickets } from 'common/api';
import { handleAuthError } from 'common/handlers';
import { Flex } from 'components';
import { useEffect, useState } from 'react';
import { ModalLoader, PageSidebar } from 'shared/components';
import { NoneTickets, TicketCard } from './components';
import './style.scss';

function PageTickets() {
  const [tickets, setTickets] = useState<IClientTicketBrief[] | null>(null);
  useEffect(() => {
    loadPayments();
  }, []);

  const loadPayments = async () =>
    await handleAuthError(async () => setTickets(await ApiTickets.getInstance().getAll()));

  return (
    <PageSidebar
      title='Мои билеты'
      frameTitle='Мои билеты'
    >
      {tickets == null && <ModalLoader />}

      {tickets != null && (
        <div>
          {tickets.length === 0 && <NoneTickets />}

          <Flex
            direction='column'
            gap={10}
          >
            {tickets.map((ticket) => (
              <TicketCard
                key={ticket.id}
                ticket={ticket}
              />
            ))}
            <div className='ticket-filler-TY2l' />
          </Flex>
        </div>
      )}
    </PageSidebar>
  );
}

export default PageTickets;
